// extracted by mini-css-extract-plugin
module.exports = {"header":"Style_header__2ejAa","prayer":"Style_prayer__1unNL","story":"Style_story__35xM-","locations":"Style_locations__1zKXx"};